import type { TimeValue, ValidationResult } from "react-aria-components";
import {
  TimeField,
  FieldError,
  Text,
  DateSegment,
  DateInput,
} from "react-aria-components";
import clsx from "clsx";

import Label from "./label";
import styles from "./time-picker.module.css";

interface TimePickerProps {
  value?: TimeValue;
  onChange?: (value: TimeValue | null) => void;
  isDisabled?: boolean;
  isRequired?: boolean;
  autofocus?: boolean;
  className?: string;
  label?: string;
  description?: string;
  errorMessage?: string | ((validation: ValidationResult) => string);
  validate?: (value: TimeValue) => string | null;
}

function TimePicker({
  onChange,
  value,
  isDisabled = false,
  isRequired = false,
  autofocus = false,
  className = "",
  label,
  description,
  errorMessage,
  validate,
}: TimePickerProps) {
  const isInvalid = errorMessage ? { isInvalid: true } : {};
  return (
    <TimeField
      validate={validate}
      value={value}
      onChange={onChange}
      isDisabled={isDisabled}
      isRequired={isRequired}
      autoFocus={autofocus}
      {...isInvalid}
      data-testid="pallet-time-picker"
      className={clsx(styles.timePicker, className)}
    >
      <Label>{label}</Label>
      <DateInput data-testid="pallet-time-input" className={styles.dateInput}>
        {(segment) => (
          <DateSegment className={styles.segment} segment={segment} />
        )}
      </DateInput>
      {description && (
        <Text data-testid="pallet-description" slot="description">
          {description}
        </Text>
      )}
      <FieldError data-testid="pallet-field-error" className={styles.error}>
        {errorMessage}
      </FieldError>
    </TimeField>
  );
}

export default TimePicker;
